"use client"; 

import { Provider } from "react-redux";
import { store } from "@features/store";

import "@public/tailwind/style.css";
import { Rubik } from "next/font/google";
import "animate.css";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { GoogleTagManager } from '@next/third-parties/google';
import Script from 'next/script';
import { IS_DEV } from "@constants/env";

const rubik = Rubik({
  weight: ["300", "400", "500", "600", "700"],
  subsets: ["latin"],
});

export default function RootLayout({ children }) {
  return (
    <html lang="fr" className="scroll-smooth hover:scroll-auto" id="top">
      <head>
        {/* Configuration langue française pour AdSense et SEO */}
        <meta httpEquiv="Content-Language" content="fr" />
        <meta name="language" content="French" />
        <meta name="google" content="notranslate" />
        
        {/* Ajout manuel des favicons */}
        <link rel="apple-touch-icon" sizes="180x180" href="/images/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="16x16 32x32" href="/images/favicon.png" />
        <link rel="manifest" href="/images/site.webmanifest" crossOrigin="use-credentials" />
       {/*<link rel="stylesheet" href="_next/static/css/app/layout.css" />*/}
      </head>
      <body className={rubik.className}>
        <Provider store={store}>{children}</Provider>
        {process.env.NODE_ENV === "production" && !IS_DEV && (
          <GoogleTagManager gtmId="GTM-KQGSDXDN" />
        )}
      </body>
    </html>
  );
}
